import styled from "styled-components";

export const RemoveButton = styled.a`
  padding: 0.125rem;
  line-height: 0;
  background: transparent;
    border: 0;
  color: #333333;
    
    &:hover{
        color: red;
    }
`;

export const SuggestionList = styled.ul`
    list-style-type: none;
    padding: .5rem 1rem .5rem 1rem;
    position: absolute;
    margin: 0;
    top: 100%;
    left: 0;
    right: 0;
    overflow: hidden;
    overflow-y: auto;
    min-width: 10rem;
    max-height: 150px;
    z-index: 99999;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* Optional: Schatten für bessere Abgrenzung */

`;

// Beispiel für die Filterung von Props in Styled Components
export const SuggestionItem = styled(({ isSelected, ...props }) => <li {...props} />)`
  cursor: pointer;
  padding: .5rem 1rem;
  background-color: ${props => props.isSelected ? '#ddd' : '#fff'};
  &:hover {
    background: #ddd;
  }
`;

/*export const SuggestionItem = styled.li.attrs(props => ({
  style: {
    backgroundColor: props.isSelected ? '#ddd' : '#fff',
  }
}))`
    cursor: pointer;
    padding: .5rem 1rem;
    &:hover {
        background: #ddd;
    }
`;*/

export const TagFieldGroup = styled.div`
    position: relative;
    border: 1px solid #ccc;
    padding: 0.5em 0.75em;
    background: #eeeeee;
    display: flex;
    flex-wrap: wrap; // Erlaubt den Tags, in Zeilen zu fließen
    align-items: flex-start;
    gap: 0.5rem;
`;

export const TagInputField = styled.input`
    flex-grow: 1; /* Ermöglicht es, die volle Breite zu nehmen */
    flex-direction: column;
    width: 100%;
    margin: 0.5rem 0; /* Fügt etwas Abstand oben und unten hinzu */
    border: none;
    font-size: 1rem;
    padding: 0.5em 0.75em;
`;

export const TagSpan = styled.span`
    display: inline-flex;
    align-items: center;
    background: white;
    padding: .25rem .5rem;
    gap: 0.25rem;
    border: 1px solid #333333;
    align-self: flex-start;
    
`;
